import React, { useContext, useEffect } from 'react';
import { useStore } from '../../../hooks/use-store';
import { CustomerServiceDashboardContext } from '../../context';
import AccountMonitorList from '../../components/AccountMonitorList/AccountMonitorList';
import styles from './CustomerServiceAdmin.module.scss';
import classNames from 'classnames/bind';
import AccountMonitoredStatus from '../../components/AccountMonitoredStatus';
import { Title } from 'Mri.Web.Common';
import RepresentativeAssignmentPanel from '../../components/RepresentativeAssignmentPanel/RepresentativeAssignmentPanel';
import {MonitoringLogList} from "../../components/MonitoringLogList";

const classes = classNames.bind(styles);

export const CustomerServiceAdmin = () => {
    const { state, dispatch } = useContext(CustomerServiceDashboardContext);
    const {} = useStore();

    useEffect(() => {
        // console.log('CustomerServiceAdmin useEffect');
    }, []);
    return (
        <>
            <Title>Monitoring Stats</Title>
            <div className={classes('dashboard')}>
                <div className={classes('monitor-list')}>
                    <AccountMonitorList />
                </div>
                <div className={classes('account-stats')}>
                    <AccountMonitoredStatus />
                </div>
                <div className={classes("log")}>
                    <MonitoringLogList />
                </div>
                <div className={classes('representatives')}>
                    {/*<RepresentativeAssignmentPanel />*/}
                </div>
            </div>
        </>
    );
};
